import Timer from './Timer';

/**
 * Used for controlling the progression of an animation using time.
 * @alias Animation.Timer.TimeTimer
 * @memberOf Animation.Timer
 * @extends Animation.Timer.Timer
 */
export default class TimeTimer extends Timer {
  /**
   * Time based timer for the {@link Animation.Animation} class.
   * @param {number} delayMs The delay in MS before the animation should begin.
   * @param {number} durationMs The duration of the animation.
   */
  constructor(delayMs, durationMs) {
    super();
    // region Define Fields.
    /**
     * @type {number} The delay in ms before the animation should start.
     * @private
     */
    this._delayMs = delayMs;

    /**
     * @type {number} The duration of the animation in MS.
     * @private
     */
    this._durationMs = durationMs;

    /**
     * @type {number|null} The timeout id used for the delay, so that it can be cancelled.
     * @private
     */
    this._timeoutId = null;

    /**
     * @type {number|null} The point at which the animation starts.
     */
    this._animationFrameStartMs = null;
    // endregion
  }

  /**
   * Starts the animation.
   */
  start() {
    this._timeoutId = setTimeout(() => { this._startAnimation(); }, this._delayMs);
  }

  /**
   * Stops the animation.
   */
  stop() {
    if (this._timeoutId !== null) {
      clearTimeout(this._timeoutId);
    }
    // TODO stop the timer if animation is running.
    // TODO look at jQuery behavour, duplicate.
  }

  /**
   * Starts the ticker, after the delay
   * @private
   */
  _startAnimation() {
    window.requestAnimationFrame((millis) => this._animationFrame(millis));
  }

  /**
   * Animation frame called from {@link window.requestAnimationFrame}.
   * @param {number} millis Milliseconds.
   */
  _animationFrame(millis) {
    if (this._animationFrameStartMs === null) {
      this._animationFrameStartMs = millis;
    }
    let current = millis - this._animationFrameStartMs;
    let percent = current / this._durationMs;

    if (percent > 1) percent = 1;
    else if (percent < 0) percent = 0;

    this.tick(percent, {current: current, total: this._durationMs});

    if (percent !== 1) {
      this._startAnimation();
    }
  }
}



// WEBPACK FOOTER //
// ./src/class/Animation/Timer/TimeTimer.js